import React, { useEffect } from 'react';
import MensajeCargando from '../../UI/MensajeCargando.js';
import MensajeError from '../../UI/MensajeError.js';
import styles from './EtapasTorneo.module.css';

const EtapasTorneo = (props) => {
  const {
    etapas = [],
    etapaSeleccionada,
    isCargando = false,
    errores = null,
    onEtapaSeleccionada,
  } = props;

  // Seleccionar la primera etapa automáticamente
  useEffect(() => {
    if (etapas.length > 0 && !etapaSeleccionada) {
      onEtapaSeleccionada(etapas[0]);
    }
  }, [etapas, etapaSeleccionada, onEtapaSeleccionada]);

  const etapaElegidaHandler = (index) => {
    onEtapaSeleccionada(etapas[index]);
  };

  return (
    <React.Fragment>
      {!isCargando && etapas.length === 0 && (
        <div className={`${styles.sinEtapas}`}>No hay etapas definidas para el torneo</div>
      )}
      {!isCargando && etapas.length > 0 && (
        <React.Fragment>
          <div className={`${styles.titulo}`}>Etapas</div>
          <div className={`${styles.listado}`}>
            {!isCargando &&
              etapas.map((etapaTorneo, index) => (
                <button
                  className={`${styles.etapa} ${
                    etapaSeleccionada && etapaSeleccionada.id === etapaTorneo.id
                      ? styles.elegido
                      : ''
                  }`}
                  key={etapaTorneo.id}
                  onClick={() => etapaElegidaHandler(index)}
                >
                  {etapaTorneo.etapa?.descripcion}
                </button>
              ))}
          </div>
        </React.Fragment>
      )}
      <MensajeCargando isCargando={isCargando} />
      <MensajeError errores={errores} />
    </React.Fragment>
  );
};

export default EtapasTorneo;
